import InstanceUtils from './instance-utils';

export default class InstanceStatusFactory {
  private InstanceStatus = InstanceUtils.InstanceStatus;

  private InstanceStatusType = InstanceUtils.InstanceStatusType;

  public getInstanceStatus(status: string, withConsumption: string | undefined): string {
    if (!status) {
      return '';
    }
    const statusMapping = {
      ACTIVE: () => (
        !withConsumption
          ? this.InstanceStatus.ACTIVE
          : this.getAtiveStatusWithConsumptionNotNull(withConsumption)
      ),
      INACTIVE: () => (
        !withConsumption
          ? this.InstanceStatus.INACTIVE
          : this.getInactiveStatusWithConsumptionNotNull(withConsumption)
      ),
      UNBOUND_CONTRACT: () => (
        !withConsumption
          ? this.InstanceStatus.UNBOUND_CONTRACT
          : this.getUnboundStatusWithConsumptionNotNull(withConsumption)
      ),
    }
    return statusMapping[status]();
  }

  private getAtiveStatusWithConsumptionNotNull(withConsumption: string): string {
    return withConsumption === this.InstanceStatusType.WITH_CONSUMPTION
      ? this.InstanceStatus.ACTIVE_WITH_CONSUMPTION
      : this.InstanceStatus.ACTIVE_WITHOUT_CONSUMPTION
  }

  private getInactiveStatusWithConsumptionNotNull(withConsumption: string): string {
    return withConsumption === this.InstanceStatusType.WITH_CONSUMPTION
      ? this.InstanceStatus.INACTIVE_WITH_CONSUMPTION
      : this.InstanceStatus.INACTIVE_WITHOUT_CONSUMPTION
  }

  private getUnboundStatusWithConsumptionNotNull(withConsumption): string {
    return withConsumption === this.InstanceStatusType.WITH_CONSUMPTION
      ? this.InstanceStatus.UNBOUND_CONTRACT_WITH_CONSUMPTION
      : this.InstanceStatus.UNBOUND_CONTRACT_WITHOUT_CONSUMPTION
  }
}
